<form
    [formGroup]="activeSearchForm"
    (ngSubmit)="onSubmit(activeSearchForm.value)"
    class="form form--embedded"
>
    <fieldset>
        <legend class="legend">Search</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="firstName"
                    class="label"
                >
                    First Name (required)
                </label>
                <input
                    class="input  input--large"
                    autocomplete="off"
                    id="firstName"
                    formControlName="firstName"
                    name="firstName"
                    type="text"
                    maxlength="30"
                >
                <div
                    *ngIf="formErrors.firstName"
                    class="error-message field__error-message"
                >
                    {{ formErrors.firstName }}
                </div>
            </div>
        </div>
        <div class="field ">
            <div class="field__label-input-wrap">
                <label
                    for="lastName"
                    class="label"
                >
                    Last Name (required)
                </label>
                <input
                    class="input  input--large"
                    autocomplete="off"
                    id="lastName"
                    formControlName="lastName"
                    name="lastName"
                    type="text"
                    maxlength="30"
                >
                <div
                    *ngIf="formErrors.lastName"
                    class="error-message field__error-message"
                >
                    {{ formErrors.lastName }}
                </div>
            </div>
        </div>

        <div>
            <details>
                <summary style="padding-bottom: 1rem;">Advanced search</summary>
                <div class="field ">
                    <div class="field__label-input-wrap">
                        <label
                            for="credential"
                            class="label"
                        >
                            Credential
                        </label>
                        <select
                            class="input input--select-menu"
                            id="credential"
                            formControlName="credential"
                            name="credential"
                        >
                            <option value="ALL">All</option>
                            <option
                                *ngFor="let item of credentialItems"
                                value="{{item.credentialCode}}"
                            >
                                {{item.credentialCode}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="field form-row__item form-row__item--half">
                        <div class="field__label-input-wrap">
                            <label
                                for="city"
                                class="label"
                            >
                                City
                            </label>
                            <input
                                class="input"
                                autocomplete="off"
                                id="city"
                                formControlName="city"
                                name="city"
                                type="text"
                                maxlength="35"
                            >
                            <div
                                *ngIf="formErrors.city"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.city }}
                            </div>
                        </div>
                    </div>
                    <div class="field form-row__item form-row__item--half">
                        <div class="field__label-input-wrap">
                            <label
                                for="state"
                                class="label"
                            >
                                State
                            </label>
                            <select
                                class="input input--select-menu"
                                autocomplete="off"
                                id="state"
                                formControlName="state"
                                name="state"
                            >
                                <option value>Select One</option>
                                <option
                                    *ngFor="let item of states"
                                    value="{{item.value}}"
                                >
                                    {{item.name}}
                                </option>
                            </select>
                            <div
                                *ngIf="formErrors.state"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.state }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field ">
                    <div class="field__label-input-wrap">
                        <label
                            for="birthdate"
                            class="label"
                        >
                            Birthdate
                        </label>
                        <input
                            *ngIf="appSettings.IsCompatibilityMode === true"
                            class="input"
                            id="birthdate"
                            formControlName="birthdate"
                            type="text"
                            mask="00/00/0000"
                            placeholder="MM/DD/YYYY"
                        >
                        <input
                            *ngIf="appSettings.IsCompatibilityMode === false"
                            class="input"
                            id="birthdate"
                            formControlName="birthdate"
                            type="date"
                            placeholder="mm/dd/yyyy"
                        >
                        <div
                            *ngIf="formErrors.birthdate"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.birthdate }}
                        </div>
                    </div>
                </div>
            </details>
        </div>
    </fieldset>
    <button
        type="submit"
        class="button button--alt"
    >
        Search
    </button>
    <a
        style="padding-left: 1rem;"
        (click)="clearForm()"
    >
        Clear
    </a>
</form>
